import CustomZObject from './CustomZObject.js';
import {setEnableRollViewer} from 'actions/index.js';
import Resolution from "engine/Resolution.js";

export default class ZRoll extends CustomZObject {
    constructor(zobject) {
        super(zobject);

        this.newInlet("roll", ([msg]) => this.onRoll(msg));
        this.newInlet("triplet roll", ([msg]) => this.onRoll(msg, true));
        this.newInlet("enable roll-viewer", ([msg]) => this.enableRollViewer(msg));
    }

    enableRollViewer(msg) {
        msg = msg ? true : false;
        this.zObject.dispatch(setEnableRollViewer(msg));
    }

    onRoll(msg, isTriplet=false) {
        if (msg <= 0) {
            // then we stop rolling
            this.sequencerEngine.sequenceRolling = false;
            this.sequencerEngine.trackRolling = false;
        } else {
            let resolution = new Resolution(msg, isTriplet);
            this.sequencerEngine.resolution = resolution;
            this.sequencerEngine.sequenceRolling = true;
            this.sequencerEngine.trackRolling = true;
        }
    }
}
